"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_METHODS = void 0;
exports.PAYMENT_METHODS = {
    LINK: 'LINK',
    CARD: 'CARD',
    GOOGLE_PAY: 'GOOGLE_PAY',
    APPLE_PAY: 'APPLE_PAY',
    PAYPAL: 'PAYPAL'
};
//# sourceMappingURL=paymentMethods.js.map